import { IAppState } from '@state/types';
import { IParsedTree } from './types';

export const getParsedTrees = (state: IAppState): any | undefined => state.parsedTrees.parsedTrees;

export const getParsedTree = (state: IAppState): any | undefined => state.parsedTrees.parsedTree;

export const getParsedTreeById = (state: IAppState, id: string): IParsedTree | undefined => state.parsedTrees.parsedTree && state.parsedTrees.parsedTree.id === id ? state.parsedTrees.parsedTree : undefined;

export const getParsedTreeResponse = (state: IAppState): any | undefined => state.parsedTrees.response;

export const getParsedTreeSearch = (state: IAppState): any | undefined => state.parsedTrees.searches;

export const getParsedTreeCounter = (state: IAppState): any | undefined => state.parsedTrees.counter;

export const getUpdatedElementsResponse = (state: IAppState): any | undefined => state.parsedTrees.updatedElementsResponse;

export const getUpdatedFieldResponse = (state: IAppState): any | undefined => state.parsedTrees.updatedFieldResponse;

export const getUpdatedFieldTagsResponse = (state: IAppState): any | undefined => state.parsedTrees.updatedFieldTagsResponse;

export const getUpdatedFieldsTagsResponse = (state: IAppState): any | undefined => state.parsedTrees.updatedFieldsTagsResponse;

export const getUpdatedTemplateFieldsResponse = (state: IAppState): any | undefined => state.parsedTrees.updatedTemplateFieldsResponse;